import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import { useDarkModeData } from "src/context/DarkModeContext";

export default function KeikkaIcon(props) {
  const { darkMode } = useDarkModeData();
  const path = "/img/keikkaIcons/";
  const keikkaData = props.keikkaData;
  const printIcon = props.printIcon || false;
  const size = props.size ? props.size : printIcon ? "120px" : "50px";
  const opacity = printIcon ? 0.1 : 0.85;
  const mirror = props.mirror || false;

  const inversePercent = darkMode === true ? "100%" : "0%";

  const styles = {
    icon: {
      opacity: opacity,
      filter: "invert(" + inversePercent + ")",
      transition: "all 2.5s ease-in-out",
      width: size,
      height: size,
      cursor: "default",
      transform: "scaleX(" + (mirror ? -1 : 1) + ")", // Mirror image
    },
  };

  const fileName = (keikkaData) => {
    if (!keikkaData.pumppu || keikkaData.pumppu.puomiError()) return "PumiPump.png";
    const pumiPump = !keikkaData?.pumppu?.isPumi ? "pump" : "pumi";
    const boom = keikkaData.pumppu.pumppuPuomi > 0 ? "boom" : "noboom";
    var emptyFull = "full";
    if (pumiPump === "pumi") {
      if (keikkaData.totM3 < 6) emptyFull = "empty";
      else if (keikkaData.totM3 <= 20) emptyFull = "half";
    } else if (keikkaData.totM3 < 20) emptyFull = "empty";

    var linja = "0b";
    if (keikkaData.pumppu.pumppuLinja >= 100) linja = "4b";
    else if (keikkaData.pumppu.pumppuLinja >= 75) linja = "3b";
    else if (keikkaData.pumppu.pumppuLinja >= 45) linja = "2b";
    else if (keikkaData.pumppu.pumppuLinja >= 10) linja = "1b";
    const name = pumiPump + "_" + boom + "_" + emptyFull + "_" + linja + ".png";
    return name;
  };

  const toolTipTxt = (keikkaData) => {
    const pumiPump = keikkaData.pumppu.isPumi ? "Pumi" : "Pumppu";
    const boom = keikkaData.pumppu.pumppuPuomi > 0 ? "puomilla" : "ei puomia";
    var emptyFull = "paljon betonia";
    if (keikkaData.totM3 < 6) emptyFull = "vähän betonia";
    else if (keikkaData.totM3 <= 20) emptyFull = "jonkin verran betonia";
    var linja = "ei linjaa";
    if (keikkaData.pumppu.pumppuLinja >= 80) linja = "paljon linjaa, lokarit tyhjäksi";
    else if (keikkaData.pumppu.pumppuLinja >= 60) linja = "reippaasti linjaa";
    else if (keikkaData.pumppu.pumppuLinja >= 30) linja = "vähän linjaa";
    else if (keikkaData.pumppu.pumppuLinja >= 10) linja = "pari letkua";
    return pumiPump + ", " + boom + ", " + emptyFull + ", " + linja;
  };
  return (
    <Tooltip
      title={!printIcon && toolTipTxt(keikkaData)}
      placement="top-end"
      arrow
      disableInteractive>
      <img
        src={path + fileName(keikkaData)}
        aria-label="Keikka ikoni"
        alt="icon"
        className="fixPrint"
        style={styles.icon}
      />
    </Tooltip>
  );
}

KeikkaIcon.propTypes = {
  keikkaData: PropTypes.object,
  printIcon: PropTypes.bool,
  mirror: PropTypes.bool,
  size: PropTypes.string,
};
